var cio_datamodel = require("cio-datamodel");
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var toSVGutil = require("./toSVGutil");
var drawTraceDataTo2D = require("./drawTraceDataTo2D");

var drawTextDataTo2D = function (svg, group, data, mirrored, isPlaceholder) {
    
    if (data.font() !== "pcbfont") {

        var text = data.text();
        if(isPlaceholder) text = '>' + text;

        var style =  {
            transform: toSVGutil.rotateTransformText(data),
            strokeWidth: data.strokeWidth(),
            fontSize: data.fontSize(),
            fontFamily: "Verdana", // data.font(), // HARDCODED TO VERDANA UNTIL BOUNDING BOX IS FIXED FOR OTHER FONTS

          //  stroke: (data.color() ? data.color() : undefined),
          //  right now we are ignoring color from data, editors have full control
            textAnchor: data.anchor(),
            alignmentBaseline: data.alignment()
        }
        //if(isPlaceholder) style.fontStyle = "italic";
        
        return svg.text(group,0,0,text, style);

    } else {
        var g = svg.group(group, null, {
            strokeWidth: data.strokeWidth(),
            stroke: (data.color() ? data.color() : undefined)
        });

        var text = data.text();
        if(isPlaceholder) text = '>' + text;

        var bb = cio_datamodel.textTracer.getBBox(text, (9 * parseInt(data.fontSize())) / 12);
        var offset = new lib_geometry.Coord(0, 0);
        switch(data.anchor()) {
            case "start" :
                offset.x = offset.x + bb.width/2;
                break;
            case "middle" :
                break;
            case "end" :
                offset.x = offset.x - bb.width/2;
                break;
        }
        switch(data.alignment()) {
            case "baseline" :
                offset.y = offset.y + bb.height/2;
                break;
            case "central" :
                break;
            case "hanging" :
                offset.y = offset.y - bb.height/2;
                break;
        }

        var traces = cio_datamodel.textTracer.text2traces(text, (9 * parseInt(data.fontSize())) / 12, offset);
        var textPos = data.pos();
        var textAngle = data.angle();

        traces.forEach(function(trace){
            drawTraceDataTo2D(svg, g, trace);
        });

        if(data.keepReadable && data.keepReadable() && data.angle() > 90 && data.angle() <= 270){
            var box = data.boundingBox();
            var centroid = box.getCenter();
            var transformed = g.setAttribute('transform',
                    'translate ('+centroid.x+','+centroid.y+')' +
                    'rotate ('+ 180 +')' +
                    'translate ('+ (-centroid.x) +','+ (-centroid.y)+')' +

                    'translate ('+textPos.x+','+textPos.y+')' +
                    'rotate ('+textAngle+')' +
                    'scale('+(mirrored?'-1':'1')+',1)'
                );
        } else {
            var transformed = g.setAttribute('transform',
           
                    'translate ('+textPos.x+','+textPos.y+')' +
                    'rotate ('+textAngle+')' +
                    'scale('+(mirrored?'-1':'1')+',1)'
                );
        }

         var box = data.boundingBox();
            var center = box.getCenter();
            console.log(center);
        
        return transformed;
    }
};

module.exports = drawTextDataTo2D;
